import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as flights from 'core/flights';
import * as utils from 'core/utils';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class SearchTabsComponent extends Vue {
    @Prop()
    value: string;

    @Prop()
    filteredSearchResults: flights.FlightFilterModel[] | [];

    @Prop()
    flightsToView?: { [uniqueId: string]: flights.FlightModel } | undefined; // Force non-reactive

    @Prop()
    cheapestFlight: flights.FlightModel | {};

    @Prop()
    fasterFlight: flights.FlightModel | {};

    @Prop()
    bestFlight: flights.FlightModel | {};

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Watch('value')
    onModeChange(value) {
        (<any>this).$ga.sendEvent('flights.results', 'sort', 'flights.results.sort.' + value, this.gaParams); 
    }
    
    switchSortingMode(mode: string) {
        this.$emit('input', mode);
    }
}